export interface DirectoryEntryRow {
  id: string;
  title: string;
  description?: string | null;
  category?: string | null;
}

interface DirectoryEntriesTableProps {
  entries: DirectoryEntryRow[];
  showCategory?: boolean;
}

export function DirectoryEntriesTable({
  entries,
  showCategory = true,
}: DirectoryEntriesTableProps) {
  if (entries.length === 0) return null;

  const hasCategory = showCategory && entries.some((e) => e.category);

  return (
    <div className="w-full border-t border-border bg-white">
      <div className="bg-sidebar-hover border-b border-border px-4 sm:px-6 py-2">
        <div className="grid grid-cols-12 gap-4 text-xs font-medium text-content-text-muted uppercase tracking-wider">
          <div className={hasCategory ? 'col-span-3' : 'col-span-4'}>Name</div>
          <div className={hasCategory ? 'col-span-7' : 'col-span-8'}>Description</div>
          {hasCategory && <div className="col-span-2">Category</div>}
        </div>
      </div>
      <div className="divide-y divide-border">
        {entries.map((entry) => (
          <div key={entry.id} className="px-4 sm:px-6 py-2 hover:bg-hover transition-colors">
            <div className="grid grid-cols-12 gap-4 items-start">
              <div className={hasCategory ? 'col-span-3' : 'col-span-4'}>
                <div className="text-sm font-medium text-gray-900">{entry.title}</div>
              </div>
              <div className={hasCategory ? 'col-span-7' : 'col-span-8'}>
                {entry.description?.trim() && (
                  <div className="text-sm text-gray-500 line-clamp-2">{entry.description}</div>
                )}
              </div>
              {hasCategory && (
                <div className="col-span-2">
                  {entry.category && (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
                      {entry.category}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
